/**
 * TODO(TEMP-FALLBACK): remove this file (or reorganize it) once `section/list`
 * and `section/list_filter` return real rows — then drop its imports in
 * `apiDataAdapters.js` and `useProfileFilterOptions.js`.
 *
 * The section catalog served when `section/list` / `section/list_filter` come
 * back empty or fail, so creating a dashboard and the Section/Profile filters
 * keep working instead of going blank.
 *
 * The keys are real: each was verified against dev by creating a dashboard
 * with it (`DSW000`). The labels are the frontend's reading of those keys —
 * the moment the catalog answers with rows, its own names replace these.
 *
 * Known gap while it is in use: the labels are not the backend's own section
 * names (`CUSTOMER.SERVICE` is "Customer 360 · Overview" on the cards, here
 * "Customer / Service"), and `CUSTOMER.REPAIRS` holds no dashboards in dev.
 */

/** Frozen all the way down: adapters hand these same references to state and modals. */
const deepFreeze = (value) => {
  Object.values(value).forEach((child) => {
    if (child && typeof child === 'object') deepFreeze(child);
  });
  return Object.freeze(value);
};

export const SECTION_FALLBACK_TREE = deepFreeze([
  {
    id: 'CUSTOMER',
    name: 'Customer',
    supportsDashboard: false,
    children: [
      { id: 'CUSTOMER.SERVICE', name: 'Service', supportsDashboard: true, children: [] },
      { id: 'CUSTOMER.REPAIRS', name: 'Repairs', supportsDashboard: true, children: [] },
    ],
  },
  {
    id: 'HOME',
    name: 'Home',
    supportsDashboard: false,
    children: [
      { id: 'HOME.OPERATIONS', name: 'Operations', supportsDashboard: true, children: [] },
    ],
  },
]);

/** The same catalog in the flat `section/list_filter` shape. */
export const SECTION_FALLBACK_FILTERS = deepFreeze(
  SECTION_FALLBACK_TREE.flatMap((group) => group.children.map((module) => ({
    sectionKey: module.id,
    name: `${group.name} / ${module.name}`,
  }))),
);

/**
 * `HOME.OPERATIONS` → "Home / Operations", for the surfaces the backend hands
 * only the key (CT-5898).
 *
 * `dashboard/list` carries a `sectionName` and `dashboard/get` does not, so the
 * card read "Home · Operaciones" while the editor and the viewer printed the
 * raw key. The author picked that section from this very catalog, so it is the
 * thing that can name it back.
 *
 * Goes when the catalog is real, like everything else in this file: then every
 * surface reads the backend's own name.
 */
export const sectionLabelForKey = (sectionKey) => {
  if (!sectionKey) return '';
  const match = SECTION_FALLBACK_FILTERS.find((option) => option.sectionKey === sectionKey);
  return match?.name ?? '';
};
